import { rp } from "@/lib/api";

export const TotalsBlock = ({ totals, testId = "bill-totals" }) => (
  <div className="space-y-1.5 text-sm" data-testid={testId}>
    <Row label="Subtotal" value={rp(totals.subtotal)} />
    {totals.discount > 0 && <Row label={`Diskon ${totals.discount_label || ""}`} value={`- ${rp(totals.discount)}`} />}
    <Row label={`Service ${totals.service_percent}%`} value={rp(totals.service)} />
    <Row label={`Pajak ${totals.tax_percent}%`} value={rp(totals.tax)} />
    <div className="flex items-center justify-between border-t border-dashed border-stone-300 pt-2 text-base font-bold">
      <span>Total</span>
      <span className="font-mono tabular-nums text-orange-700" data-testid={`${testId}-total`}>{rp(totals.total)}</span>
    </div>
  </div>
);

const Row = ({ label, value }) => (
  <div className="flex items-center justify-between text-zinc-600">
    <span>{label}</span>
    <span className="font-mono tabular-nums">{value}</span>
  </div>
);

export const ItemStatus = ({ item }) => {
  if (item.delivered) return <span className="text-xs font-semibold text-emerald-700">Diantar</span>;
  if (item.kitchen_ready) return <span className="text-xs font-semibold text-purple-700">Keluar dapur</span>;
  return <span className="text-xs font-semibold text-amber-700">Dimasak</span>;
};
